import { default as AkBanner, type BannerProps as AkBannerProps } from '@atlaskit/banner';

import type {
	ChoreographedComponentProps,
	ChoreographerMessageTypes,
	ChoreographerUtilities,
} from '../../types';
import { wrapComponentForChoreographer } from '../utils';

export const Banner: {
	({
		shouldBeChoreographed,
		withChoreographedRender,
		...props
	}: AkBannerProps &
		ChoreographerUtilities &
		Partial<ChoreographedComponentProps> & {
			messageType?: ChoreographerMessageTypes;
		}): React.JSX.Element;
	displayName: string;
} = wrapComponentForChoreographer<AkBannerProps>(AkBanner);
